import React from "react";
import { SkeletonLine, SkeletonField, SkeletonFieldRow, SkeletonFieldGroup } from "./styles";

interface SkeletonLoaderProps {
  rows?: number;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ rows = 3 }) => {
  return (
    <div style={{ padding: '1.5rem' }}>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonFieldRow key={i}>
          <SkeletonFieldGroup>
            <SkeletonField>
              <SkeletonLine width="30%" height="14px" style={{ marginBottom: '0.5rem' }} />
              <SkeletonLine width="100%" height="38px" />
            </SkeletonField>
          </SkeletonFieldGroup>
          {i < rows - 1 && (
            <SkeletonFieldGroup>
              <SkeletonField>
                <SkeletonLine width="40%" height="14px" style={{ marginBottom: '0.5rem' }} />
                <SkeletonLine width="100%" height="38px" />
              </SkeletonField>
            </SkeletonFieldGroup>
          )}
        </SkeletonFieldRow>
      ))}
    </div>
  );
};
